import { render, staticRenderFns } from "./gc-side-nav-menu.vue?vue&type=template&id=5321f84a"
import script from "./gc-side-nav-menu.vue?vue&type=script&lang=js"
export * from "./gc-side-nav-menu.vue?vue&type=script&lang=js"
import style0 from "./gc-side-nav-menu.vue?vue&type=style&index=0&id=5321f84a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports